import React from 'react';
import TableRender from '../../../DataTable/TableRender';
import config from '../../../../../config/config';
import RolePermissions from '../../../DataTable/Permissions';
import fetchMethodRequest from '../../../../../config/service'
import apiCalls from '../../../../../config/apiCalls';

export default class TicketsTable extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            ticketSubjectCategoryTypes: []
        };
    }
    componentDidMount = async () => {
        return fetchMethodRequest('GET', apiCalls.Settings)
            .then(async (response) => {
                if (response && response.settings && response.settings[0]) {
                    if (response.settings[0]) {
                        let ticketSubjectCategoryTypes = this.getticketTypeDrodownValues(response.settings[0]);
                        this.setState({
                            ticketSubjectCategoryTypes: ticketSubjectCategoryTypes,

                        });
                    }
                }
            });
    }

    getticketTypeDrodownValues = (settingInfo) => {
        if (settingInfo && settingInfo.ticketSubjectcategory) {
            let modifiedticketSubjectCategoryTypes = [];
            for (let ticket of settingInfo.ticketSubjectcategory) {
                modifiedticketSubjectCategoryTypes.push({
                    label: ticket,
                    value: ticket
                })
            }
            return modifiedticketSubjectCategoryTypes;
        }
    }

    getTableFields = () => {
        let data = [
            { textAlign: 'center', width: 50, field: 'Sno', header: 'S.No', filter: false, sortable: false, },
            { textAlign: 'left', width: 100, field: 'created', header: 'Created On', filter: true, sortable: true },
            { textAlign: 'center', width: 120, field: 'subject', header: 'Subject', filter: true, sortable: true, },
            { textAlign: 'center', width: 125, field: 'category', header: 'Category', filter: true, sortable: true },
            { textAlign: 'center', width: 70, field: 'Actions', header: 'Actions', filter: false, sortable: false },
        ];

        let screenPermissions = RolePermissions.screenPermissions('Ticket Subjects');
        if (screenPermissions && screenPermissions != 'edit') {
            data.pop();
        }
        return data;
    };

    getFormFields = () => {
        return ([
            { required: true, value: '', type: 'dropDown', name: 'category', label: 'Category', id: 'category', options: this.state.ticketSubjectCategoryTypes, placeholder: 'Select' },
            { required: true, value: '', type: 'text', name: 'subject', label: 'Subject', id: 'subject', placeholder: 'Select' },

        ]);
    }

    render() {
        return (
            <div>
                <TableRender type='Ticket Subjects'
                    globalSearch='Subject/Category'
                    tableFields={this.getTableFields}
                    formFields={this.getFormFields} {...this.props}
                />
            </div>
        );
    }
}